module.exports = __webpack_public_path__ + "static/media/KE.732c2b39.svg";